/* eslint-disable no-console */
import React, { useEffect, useState } from 'react';

const MeetingCountdown = (props:any) =>
{
	const { joinDetails } = props;
	const [ countdown, setCountdown ] = useState({
		days    : 0,
		hours   : 0,
		minutes : 0,
		seconds : 0
	});

	const getCountDown = () =>
	{
		const presentTime = new Date().getTime();
		const startTime = joinDetails?.startTime;
		const timeToStart = Math.max(startTime - presentTime, 0);
		const days = Math.floor(timeToStart / (1000 * 60 * 60 * 24));
		const hours = Math.floor((timeToStart % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
		const minutes = Math.floor((timeToStart % (1000 * 60 * 60)) / (1000 * 60));
		const seconds = Math.floor((timeToStart % (1000 * 60)) / 1000);

		setCountdown({ days, hours, minutes, seconds });
		if (timeToStart > 0)
		{
			setTimeout(getCountDown, 1000);
		}
		else
		{
			console.log('Countdown reached!');
		}
	};

	useEffect(() =>
	{
		getCountDown();
	}, [ joinDetails ]);

	return (

		<div className='flexCol pdngVSM mrgnVXXS'>
			<span className='headingMD fontWeightMD'>Starting In</span>
			<div className='flexRow'>
				<div className='flexAutoCol pdngRXS alignCntr justifyCntr'>
					<span className='fontWeightMD pdngBSM'>{countdown?.days}</span>
					<span>Days</span>
				</div>
				<div className='flexAutoCol pdngXS alignCntr justifyCntr'>
					<span className='fontWeightMD pdngBSM'>{countdown?.hours}</span>
					<span>Hours</span>
				</div>
				<div className='flexAutoCol pdngXS alignCntr justifyCntr'>
					<span className='fontWeightMD pdngBSM'>{countdown?.minutes}</span>
					<span>Minutes</span>
				</div>
				<div className='flexAutoCol pdngXS alignCntr justifyCntr'>
					<span className='fontWeightMD pdngBSM'>{countdown?.seconds}</span>
					<span>Seconds</span>
				</div>
			</div>
		</div>
	);
};

export default MeetingCountdown;